import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import MaterialSelect from '../../../../../components/MaterialSelect'
import MaterialInput from '../../../../../components/MaterialInput'
import '../ActiveRuns/index.css'
import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip, IconButton, Menu, MenuItem } from '@mui/material'
import MaterialButton from '../../../../../components/MaterialButton'
import { MoreVert } from '@mui/icons-material';
import TestCaseStatus from '../ActiveRuns/components/TestCaseStatus'
import MaterialBox from '../../../../../components/MaterialBox'
import MaterialTypography from '../../../../../components/MaterialTypography'
import { fetchData, deleteData } from '../../../../Utils/Baseurl'
import { useNavigate } from 'react-router-dom'
import { useLoading } from '../../../../../context/loadingcontext'

const ClosedRuns = ({ project, handleProjectChange, input, projectLists }) => {
  const { setCirleLoading } = useLoading();
  const navigate = useNavigate();
  const [runs, setRuns] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRunId, setSelectedRunId] = useState(null);
  const [activeMenuRun, setActiveMenuRun] = useState(null);

  const handleMenuOpen = (event, run) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuRun(run);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenuRun(null);
  };


  const fetchClosedRuns = React.useCallback(async (projectId) => {
    setCirleLoading(true);
    try {
      const user_id = sessionStorage.getItem("currentUser")
      const response = await fetchData(`api/testrun/?project_id=${projectId}&flag=2&user_id=${user_id}`);
      if (response && response.data) {
        // Map API response to table expected format
        const formattedRuns = response.data.map(run => ({
          ...run,
          name: run.name,
          id: run.pk || run.id,
          user: run?.ran_by || run.assigned_to_name || run.created_by_name || "User",
          timeAgo: run.created_at ? new Date(run.created_at).toLocaleDateString() : "-",
          tests: run.test_cases_count || run.test_cases?.length || 0,
          duration: run.duration || "-",
          passed: run.total_tests?.passed || run.passed_count || 0,
          failed: run.total_tests?.failed || run.failed_count || 0,
          skipped: run.total_tests?.skipped || run.skipped_count || 0,
          blocked: run.total_tests?.blocked || 0,
          retest: run.total_tests?.retest || 0,
          untested: run.total_tests?.untested || 0,
          total: run.total_tests?.total || run.total_count || 0,
          passedPercent: run.passed_percent || 0,
          failedPercent: run.failed_percent || 0,
          skippedPercent: run.skipped_percent || 0,
          totalPercent: 100,
          failureAnalysis: "-",
          progress: `${run.progress || 0}%`,
          test_plan_name: run.test_plan_title,
        }));
        setRuns(formattedRuns);
      } else {
        setRuns([]);
      }
    } catch (error) {
      console.error("Error fetching closed runs:", error);
      setRuns([]);
    } finally {
      setCirleLoading(false);
    }
  }, [setCirleLoading]);

  useEffect(() => {
    if (project && project.value) {
      fetchClosedRuns(project.value);
    }
  }, [project, fetchClosedRuns]);

  const handleDeleteRun = async (runId) => {
    setCirleLoading(true);
    try {
      await deleteData(`api/testrun/${runId}/`);
      if (project && project.value) {
        fetchClosedRuns(project.value);
      }
    } catch (error) {
      console.error("Error deleting run:", error);
    } finally {
      setCirleLoading(false);
      handleMenuClose();
    }
  }


  const handleViewRun = (runId) => {
    setSelectedRunId(runId);
    setOpenDialog(true);
    handleMenuClose();
  };

  const handleEditRun = (runId) => {
    navigate('/test-run/create-test-run', { state: { id: runId } });
    handleMenuClose();
  }

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRunId(null);
  };



  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 2, padding: 1 }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
        <MaterialBox sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <MaterialTypography variant="caption" sx={{ color: 'text.disabled' }}>
            Project
          </MaterialTypography>
          <MaterialSelect
            label="Project"
            value={project}
            size='small'
            options={projectLists.map((project) => {
              return {
                value: project.value,
                label: project.label,
              }
            })}
            onChange={handleProjectChange}
          />
        </MaterialBox>

        <MaterialInput
          label='Search by name,tag,build'
          placeholder='Search by name,tag,build'
          size='small'
          value={input}
          sx={{ maxWidth: '300px' }}
        />
      </Box>

      <div className="table-container">
        <table className="test-run-table">
          <thead>
            <tr>
              <th>RUNS</th>
              <th>TEST PLAN</th>
              <th>TEST CASES</th>
              <th>DURATION</th>
              <th>TESTS STATUS</th>
              {/* <th>FAILURE ANALYSIS</th> */}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {runs.length > 0 ? (
              runs.map((run, index) => (
                <tr key={index}>
                  <td>
                    <div className="run-info">
                      <div
                        className={`progress-circle ${run.progress === "100%" ? "complete" : ""}`}
                      >
                        {run.progress}
                      </div>
                      <div>
                        <div className="run-title">
                          {run.name} <span className="run-id">{run.id}</span>
                        </div>
                        <div className="run-subtitle">
                          Ran by {run.user} {run.timeAgo}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td>{run.test_plan_name || "-"}</td>
                  <td>{run.total}</td>
                  <td>{run.duration || "-"}</td>

                  <td>
                    <div className="status-badges">
                      <Tooltip title={`Passed`} arrow>
                        <span className="status passed">{run.passed}</span>
                      </Tooltip>
                      <Tooltip title={`Failed`} arrow>
                        <span className="status failed">{run.failed}</span>
                      </Tooltip>
                      <Tooltip title={`Skipped`} arrow>
                        <span className="status skipped">{run.skipped}</span>
                      </Tooltip>
                      <Tooltip title={`Blocked`} arrow>
                        <span className="status blocked">{run.blocked}</span>
                      </Tooltip>
                      <Tooltip title={`Retest`} arrow>
                        <span className="status retest">{run.retest}</span>
                      </Tooltip>
                      <Tooltip title={`Untested`} arrow>
                        <span className="status untested">{run.untested}</span>
                      </Tooltip>
                      <Tooltip title={`Total`} arrow>
                        <span className="status total">{run.total}</span>
                      </Tooltip>
                    </div>
                  </td>

                  {/* <td>{run.failureAnalysis || "-"}</td> */}

                  <td className="menu-cell">
                    <IconButton size="small" onClick={(e) => handleMenuOpen(e, run)}>
                      <MoreVert />
                    </IconButton>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                  No closed runs found.
                </td>
              </tr>
            )}

          </tbody>
        </table>
      </div>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
            borderRadius: '12px',
            minWidth: '160px',
            mt: 0.5
          }
        }}
      >
        <MenuItem onClick={() => handleViewRun(activeMenuRun?.id)} sx={{ fontSize: '14px' }}>
          View Run
        </MenuItem>
        <MenuItem onClick={() => handleEditRun(activeMenuRun?.id)} sx={{ fontSize: '14px' }}>
          Edit Run
        </MenuItem>
        <MenuItem onClick={() => handleDeleteRun(activeMenuRun?.id)} sx={{ fontSize: '14px', color: '#dc2626' }}>
          Delete
        </MenuItem>
      </Menu>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth={false}
        PaperProps={{
          sx: {
            width: '85vw',
            height: '90vh',
            borderRadius: 2,
            overflow: 'hidden',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontSize: '16px',
            fontWeight: 'bold',
            padding: '8px 16px',
            borderBottom: '1px solid #e0e0e0',
          }}
        >
          View Run Details
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 2,
            overflow: 'auto',
            '&::-webkit-scrollbar': { display: 'none' },
          }}
        >
          <TestCaseStatus runId={selectedRunId} />
        </DialogContent>

        <DialogActions sx={{ padding: '8px 16px', borderTop: '1px solid #e0e0e0' }}>
          <MaterialButton
            onClick={handleCloseDialog}
            variant="outlined"
            color="dark"
            size="small"
          >
            Close
          </MaterialButton>
          <MaterialButton variant="contained" color="dark" size="small">
            Submit
          </MaterialButton>
        </DialogActions>
      </Dialog>

    </Box>
  )
}

export default ClosedRuns
